import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { axiosService } from "../services/axios.service";
import { StoreState } from "../store/store";
import { useSelector } from "react-redux";

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  maxWidth: 500,
  margin: "2rem auto",
  textAlign: "center",
}));

const SuccessIcon = styled(CheckCircleOutlineIcon)(({ theme }) => ({
  fontSize: 80,
  color: theme.palette.success.main,
  marginBottom: theme.spacing(2),
}));

const PaymentSuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state: StoreState) => state.user.loggedInUser);
  const [savedStatus, setSavedStatus] = useState(false);
  useEffect(() => {
    // Clean up payment retry data on successful payment
    localStorage.removeItem('paymentRetryData');
    
    const queryParams = new URLSearchParams(location.search);
    const status = queryParams.get("status");
    const id = queryParams.get("id");
    const amount = queryParams.get("order_amount");
    const currency = queryParams.get("order_currency");
    const product = queryParams.get("product");
    const customer_email = queryParams.get("customer_email");
    const customer_name = queryParams.get("customer_name");
    const card = queryParams.get("card");
    const four_digits = card?.slice(-4);

    const data = {
      status,
      orderId: id,
      amount,
      currency,
      product,
      userId: user?.id,
      four_digits,
      customer_email,
      card_holder_name: customer_name
    }

    if (status && id && !savedStatus) {

      (async () => {
        await axiosService.post<PaymentResponse>("/payment/save?provider=bridgerpay", data);
      })();

      setSavedStatus(true)
    }
  }, [location]);

  return (
    <Box sx={{ p: 3 }}>
      <StyledPaper elevation={3}>
        <SuccessIcon />
        <Typography variant="h4" component="h1" gutterBottom>
          Payment Successful!
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Thank you for your payment. Your transaction has been completed
          successfully.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/dashboard")}
          sx={{ mt: 2 }}
        >
          Return to Dashboard
        </Button>
      </StyledPaper>
    </Box>
  );
};

export default PaymentSuccessPage;
